import type { ReactNode } from 'react';
import { MantineThemeProvider } from '@cowbell/ui';
import classes from '../../theme/broker.module.css';
import type { ThemeAdapter } from '../adapters/types';
import { BROKER_THEME } from './BrokerThemeProvider';

interface BrokerQuestionsThemeProps {
  /** The console's colour scheme, as the theme port reports it to the experience. */
  readonly colorScheme: ThemeAdapter['colorScheme'];
  readonly children: ReactNode;
}

/**
 * The experience's theme and text, for a console screen that draws the broker's questions outside the experience: the
 * same component defaults, colour scheme and text the ground gives them, without the ground's full-window column.
 */
export function BrokerQuestionsTheme({
  colorScheme,
  children,
}: BrokerQuestionsThemeProps) {
  return (
    <MantineThemeProvider
      forceColorScheme={colorScheme}
      themeOverrides={BROKER_THEME}
    >
      <div className={classes.text}>{children}</div>
    </MantineThemeProvider>
  );
}
